/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ServiceType } from '../../models/service-type';
import { TransactionAcquisitionSummaryPagedList } from '../../models/transaction-acquisition-summary-paged-list';

export interface SearchTransactionAcquisitionSummary$Params {

/**
 * The list items offset
 */
  offset?: number;

/**
 * The list items limit
 */
  limit?: number;

/**
 * The start date time of data to filter
 */
  startDateTime?: string;

/**
 * The end date time of data to filter
 */
  endDateTime?: string;

/**
 * The station service type for filter
 */
  serviceTypes?: Array<ServiceType>;
}

export function searchTransactionAcquisitionSummary(http: HttpClient, rootUrl: string, params?: SearchTransactionAcquisitionSummary$Params, context?: HttpContext): Observable<StrictHttpResponse<TransactionAcquisitionSummaryPagedList>> {
  const rb = new RequestBuilder(rootUrl, searchTransactionAcquisitionSummary.PATH, 'post');
  if (params) {
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('startDateTime', params.startDateTime, {});
    rb.query('endDateTime', params.endDateTime, {});
    rb.query('serviceTypes', params.serviceTypes, {"style":"form","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TransactionAcquisitionSummaryPagedList>;
    })
  );
}

searchTransactionAcquisitionSummary.PATH = '/custom/stations/transaction-acquisition/summary/search';
